module.exports = __webpack_public_path__ + "static/media/course-tile-with-highlight.f60e95f3.png";